import { TenantFeature } from '../../../shares/enums/tenantFeatures';
import { isTenantFeatureEnabled } from '../../../shares/helpers/tenantFeatureHelper';
import { simulateSpecialsElements } from './simulateSpecialsElements';
import { getRawAddEventListener } from '../../../shares/lib/rawEventListener';

let timeoutId = undefined as unknown as ReturnType<typeof setTimeout>;

export function renderSimulateSpecialsIframe(
  containers: HTMLElement[],
  iframeUrl: string,
  hideLoader: () => void,
) {
  const rawAddEventListener = getRawAddEventListener();
  const messageController = new AbortController();
  const iframeOnLoadType = 'Simulate-Specials-Has-Loaded';
  const iframeTimeoutMs = 30_000;

  const iframes: HTMLIFrameElement[] = [];
  let loadedCount = 0;
  const totalContainers = containers.length;

  const promises = containers.map((container, index) => {
    return new Promise<HTMLIFrameElement>((resolve, reject) => {
      const iframe = document.createElement('iframe');
      iframe.style.width = '100%';
      iframe.style.height = '100%';
      iframe.style.border = 'none';
      iframe.src = iframeUrl;
      iframe.hidden = true;
      iframes.push(iframe);

      if (
        isTenantFeatureEnabled([TenantFeature.SIMULATE_SPECIALS_OTP_IN_URL])
      ) {
        iframe.addEventListener('load', () => {
          console.log(`Iframe ${index + 1} loaded`);
          iframe.hidden = false;
          loadedCount++;
          if (loadedCount === totalContainers) {
            hideLoader();
          }
          resolve(iframe);
        });
      } else {
        const expectedOrigin = new URL(iframeUrl).origin;

        rawAddEventListener(
          'message',
          (message: MessageEvent) => {
            // Verify the origin of the received message
            if (message.origin !== expectedOrigin) {
              return;
            }

            if (message.data.type === iframeOnLoadType) {
              iframe.hidden = false;
              loadedCount++;
              if (loadedCount === totalContainers) {
                hideLoader();
              }
              resolve(iframe);
            }
          },
          { signal: messageController.signal },
        );

        iframe.addEventListener('error', (e) => {
          console.error(`Iframe ${index + 1} error:`, e);
          reject(new Error(`An error occurred ${e.message}`));
        });

        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
          console.error(`Iframe ${index + 1} load timeout`);
          reject(new Error('An error occurred. Please try again later.'));
        }, iframeTimeoutMs);
      }

      if (container.hidden) {
        container.hidden = false;
      }

      if (container.parentElement?.hidden) {
        container.parentElement.hidden = false;
      }

      container.replaceChildren(iframe);
    });
  });

  simulateSpecialsElements.iframes = iframes;

  return Promise.all(promises).finally(() => {
    clearTimeout(timeoutId);
    messageController.abort();
  });
}
